export default {
  path: 'partners/:id',
  name: 'Partner',
  component: () => import(/* webpackChunkName: "administration" */ '../views/PartnerView.vue')
}
